<script>
  // import Map from "./Map.svelte"
  import CausesOfDeath from "./CausesOfDeath.svelte";
  import BubblesScroller from "./BubblesScroller.svelte";
  import Calculator from "./Calculator.svelte";
  import GlobeVideo from "./GlobeVideo.svelte";
  // import GlobeWrapper from "./GlobeWrapper.svelte";
  import Footer from "./Footer.svelte";
  import RhodiumFooter from "./RhodiumFooter.svelte";
  import RhodiumHeader from "./RhodiumHeader.svelte";
  import Text from "./Text.svelte";
  import Gradient from "./Gradient.svelte";
  import * as copy from "./../content/data.json";
</script>

<RhodiumHeader />

<div class="main-content">
  <div class="c">
    <article>
      <div class="intro">
        <!-- <h1>{copy.headline}</h1>
      <h3>{copy.deck}</h3> -->

        <div class="heading">
          <Text text="{copy.intro}" />
        </div>

        <CausesOfDeath />

        <GlobeVideo />
        <!-- <GlobeWrapper /> -->
      </div>
      <div class="content">

        <Text text="{copy.after_map}" />

        <Text text="{copy.dots_intro}" />

        <BubblesScroller />

        <Text text="{copy.after_dots}" />

      </div>
    </article>
  </div>
  <!-- <div class="calculator-transition">
  <Gradient colors="{['#0b0a25', '#fff']}" />
</div> -->

  <div class="calculator" id="calculator">
    <div class="calculator-content">
      <h2>{copy.calculator.title}</h2>

      <Calculator />
    </div>
  </div>

  <Footer />
</div>

<RhodiumFooter />

<style>
  .main-content {
    /* padding-top: 90px; */
  }
  .c {
    padding: 15vh 2em 16em;
    background: #2d3940;
    color: #dee1ed;
    background: var(--bgc);
    /* background: #0f0f33;
    color: white; */
  }
  .c :global(strong) {
    color: white;
  }
  .intro {
  }
  .heading {
    font-size: 1.4em;
    line-height: 1.5em;
    max-width: 43em;
    padding: 0 1em;
    margin: 0 auto;
  }
  .heading :global(b) {
    color: var(--c2);
  }
  .heading :global(.tooltip) {
    display: inline-block;
    position: relative;
    cursor: help;
  }
  .heading :global(.tooltip:before) {
    content: attr(data-text);
    position: absolute;
    top: 0;
    left: 50%;
    background: white;
    padding: 0.6em 1em;
    transform: translate(-50%, -100%);
    min-width: 20em;
    max-width: 60vw;
    opacity: 0;
    box-shadow: var(--box-shadow);
    font-size: 1rem;
    line-height: 1.3em;
    color: var(--bgc);
    /* pointer-events: none; */
    transition: all 0.2s ease-out;
  }
  .heading :global(.tooltip:hover:before) {
    opacity: 1;
    transform: translate(-50%, calc(-0.3em + -100%));
  }
  @media (max-width: 560px) {
    .heading {
      padding: 0;
    }
    .heading :global(.tooltip:before) {
      max-width: 30em;
      min-width: 14em;
    }
  }
  .content {
    max-width: 58em;
    margin: auto;
  }
  .content > :global(p) {
    max-width: 40em;
    margin-left: auto;
    margin-right: auto;
  }
  article {
    text-align: center;
  }
  .calculator {
    position: relative;
    padding: 0 2em 6em;
    color: #0b0a25;
  }
  /* .calculator:before {
    content: "";
    position: absolute;
    top: -40em;
    left: 0;
    right: 0;
    height: 50em;
    background: linear-gradient(to bottom, #0b0a25, #fff);
  } */
  /* .calculator-transition {
    margin: -20em 0 -10em;
    position: relative;
    z-index: 5;
  } */
  .calculator h2 {
    margin-top: 1em;
    color: #0b0a25;
  }
  .calculator-content {
    max-width: 62em;
    margin: auto;
    background: white;
    margin-top: -6.5em;
    position: relative;
    padding: 1em 4em;
    z-index: 10;
  }
  @media (max-width: 800px) {
    .calculator {
      padding-left: 0;
      padding-right: 0;
    }
    .calculator-content {
      padding: 1em 2em;
    }
  }
</style>
